import { customerColumns } from "../../Data/Customers/CustomerData";
import React, { Fragment, useContext, useEffect, useState } from "react";
import CommonDataTable from "../Common/Component/CommonDataTable";
import { Link } from "react-router-dom";
import ActionOptions from "../Common/Component/ActionOptions";
import QuickActions from "./QuickActions";
import DataTable from "react-data-table-component";
import DeleteCustomer from "./DeleteCustomer";
import { getUserRole } from "../../Services/Shared.service";
import { Admin } from "../../Data/SideMenu/RouteMapping";
import { Spinner } from "../../AbstractElements";
import CustomizerContext from "../../_helper/Customizer";
const CustomerTable = (props) => {
  const userRole = getUserRole();
  const [customerObj, setCustomerObj] = useState({});
  const [deleteCustomerModal, setDeleteCustomerModal] = useState(false);
  const toggleDeleteCustomerModal = () =>
    setDeleteCustomerModal(!deleteCustomerModal);
  const {mix_background_layout} = useContext(CustomizerContext)
  const processData = props.customerData.map((element, i) => {
    return {
      customer_name: (
        <Link
          to={`${process.env.PUBLIC_URL}/customers/customer-profile/${element.id}`}
          onClick={() => props.setPageNumber(props.pagination)}
          state={{ previousUrl: window.location.pathname,filterdata: props.filterData,searchdata: props.searchData }}
        >
          {element.fullName}
        </Link>
      ),
      phone_number: element.mobile,
      email: element.email,
      city: element.city ? element.city : "-",
      vip: element.isVip ? (
        <i className="fa fa-star"></i>
      ) : (
        <i className="fa fa-star-o"></i>
      ),
      // international: <Globe className={element.isInternational? 'international-customer':''}/>,
      corporate: element.isCorporateAccount ? (
        <i className="fa fa-building"></i>
      ) : (
        <i className="fa fa-building-o"></i>
      ),
      created_via: element.createdViaType ? element.createdViaType : "-",
      action: userRole.includes(Admin) ? (
        <ActionOptions key={i}>
          <QuickActions
            element={element}
            setCustomerObj={setCustomerObj}
            toggleDeleteCustomerModal={toggleDeleteCustomerModal}
          />
        </ActionOptions>
      ) : (
        ""
      ),
    };
  });
  return (
    <Fragment>
      <div className="table-responsive customer-table">
        <DataTable
          columns={customerColumns}
          data={processData}
          center={true}
          fixedHeader
          fixedHeaderScrollHeight={"57vh"}
          pagination
          paginationDefaultPage={props.pageNumber}
          paginationPerPage={props.paginationPerPage}
          paginationTotalRows={props.paginationTotalRows}
          onChangePage={props.onChangePage}
          onChangeRowsPerPage={props.onChangeRowsPerPage}
          paginationServer
          progressPending={props.loader}
          progressComponent={<div className="loader-box" style={{ height:"57vh" }}>
            <Spinner attrSpinner={{ className: "loader-3", style: { width: "30px", height: "30px", borderColor: "#39B54A", borderBottomColor: "transparent" } }} />
          </div>}
        // customStyles={customStyles}
        theme={mix_background_layout == "dark-only" ? "dark" : "default"}
        />
      </div>
      <DeleteCustomer
        LargeModaltoggle={toggleDeleteCustomerModal}
        title={"Delete customer"}
        Large={deleteCustomerModal}
        setShowApiLoader={props.setLoader}
        customerObj={customerObj}
        fetchCustomerData={props.fetchCustomerData}
      />
    </Fragment>
  );
};
export default CustomerTable;
